import { useEffect, useState } from 'react';
import axios from 'axios';
import { AuthStatus, useAuth } from '../auth';
import { DataGrid } from '@mui/x-data-grid';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


import '../styles/documents.scss';



import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";



import NavBar from './navbar';
import Menu   from './menu';
import { determinadoTemplate, indeterminadoPruebaTemplate, indeterminadoCapacitacionTemplate, indeterminadoTemporadaTemplate, indeterminadoTemplate} from './templates';


const endpoint = process.env.REACT_APP_ENDPOINT;


const Documents = ()=>{
    const status = AuthStatus();
    const navigate = useNavigate();
    const { token } = useAuth();


    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState({});
    const [collaborators, setCollaborators] = useState([]); 
    const [companyCollaborators, setCompanyCollaborators] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [selectedDocument, setDocument] = useState({});
    const [searchTerm, setSearchTerm] = useState('');

    const [selectedType, setSelectedType] = useState("");

    const contractTypes = [
        { value: "obra", label: "Contrato por obra determinada" },
        { value: "determinado", label: "Contrato por tiempo determinado" },
        { value: "indeterminado_capacitacion", label: "Contrato indeterminado con capacitación" },
        { value: "indeterminado_prueba", label: "Contrato indeterminado con prueba" },
        { value: "indeterminado_temporada", label: "Contrato indeterminado por temporada" },
        { value: "indeterminado", label: "Contrato por tiempo indeterminado" }
    ];

    const handleEdit = (item) => {
        navigate("/admin/contract", { 
            state: { 
                new: item.tipo,
                contract: item
            } 
        });
    }

    const populateTemplate = (contractData) => {
        let company = companies.find(c => c.id === contractData.company_id) || {};
        let collaborator = collaborators.find(c => c.id === contractData.collaborator_id) || {};

        // Mapeo de placeholders a datos del contrato
        var replacements = {
            // Información de la empresa
            '[patron]': company.nombre || 'NOMBRE DE LA EMPRESA',
            '[representante_legal]': company.representante_legal || 'REPRESENTANTE LEGAL',
            '[actividad]': contractData.actividad || 'ACTIVIDAD DE LA EMPRESA',
            '[domicilio_fiscal]': contractData.company_address || 'DOMICILIO FISCAL',
            '[rfc]': company.rfc || 'RFC EMPRESA',
            
            // Información del colaborador
            '[colaborador]': contractData.nombre || 'NOMBRE DEL COLABORADOR',
            '[puesto]': contractData.puesto || 'PUESTO',
            '[sexo]': collaborator.sexo || 'SEXO',
            '[fecha_nacimiento]': collaborator.fecha_nacimiento || 'FECHA DE NACIMIENTO',
            '[identificacion]': contractData.identificacion || 'IDENTIFICACIÓN OFICIAL',
            '[domicilio_particular]': collaborator.domicilio || 'DOMICILIO PARTICULAR',
            '[rfc_trabajador]': collaborator.rfc || 'RFC TRABAJADOR',
            '[curp]': collaborator.curp || 'CURP',
            '[nss]': collaborator.nss || 'NÚMERO DE SEGURIDAD SOCIAL',
            '[nacionalidad]': collaborator.nacionalidad || 'NACIONALIDAD',
            '[edad]': collaborator.edad || 'EDAD',
            '[estado_civil]': collaborator.estado_civil || 'ESTADO CIVIL',
            '[email]': collaborator.email || 'EMAIL NO ESPECIFICADO',
            '[beneficiarios]': collaborator.beneficiarios || 'BENEFICIARIOS NO ESPECIFICADOS',
            
            // Campos del contrato
            '[fecha_celebracion]': contractData.fecha_celebracion || new Date().toLocaleDateString('es-MX'),
            '[lugar_ciudad]': contractData.lugar_ciudad || 'CIUDAD',
            '[lugar_estado]': contractData.lugar_estado || 'ESTADO',
            '[fecha_generacion]': new Date().toLocaleDateString('es-MX'),
            
            // Campos específicos por tipo de contrato
            '[motivo]': contractData.motivo || 'MOTIVO NO ESPECIFICADO',
            '[duracion]': contractData.duracion || 'DURACIÓN NO ESPECIFICADA',
            '[cliente]': contractData.cliente || 'CLIENTE NO ESPECIFICADO',
            '[descripcion_obra]': contractData.descripcion_obra || 'DESCRIPCIÓN DE OBRA NO ESPECIFICADA',
            '[tipo_empleado]': contractData.tipo_empleado || 'TIPO NO ESPECIFICADO',
            '[prueba]': contractData.prueba || 'DÍAS NO ESPECIFICADOS',
            '[razon]': contractData.razon || 'RAZÓN NO ESPECIFICADA',
            '[temporada]': contractData.temporada || 'TEMPORADA NO ESPECIFICADA',
            '[fin_temporada]': contractData.fin_temporada || 'FECHA NO ESPECIFICADA',
            
            // Campos adicionales comunes
            '[lugar_trabajo]': contractData.lugar_trabajo || 'LUGAR DE TRABAJO NO ESPECIFICADO',
            '[horario_trabajo]': contractData.horario_trabajo || 'HORARIO NO ESPECIFICADO',
            '[salario]': contractData.salario || 'SALARIO NO ESPECIFICADO',
            '[forma_pago]': contractData.forma_pago || 'FORMA DE PAGO NO ESPECIFICADA',
            '[nombre_patron]': contractData.company_id || 'NOMBRE DEL PATRÓN'
        };

        let template;

        switch (contractData.tipo) {
            case 'obra':
                template = determinadoTemplate;
                // Agregar reemplazos específicos para obra
                replacements['[descripcion_obra]'] = contractData.descripcion_obra || 'OBRA NO ESPECIFICADA';
                replacements['[duracion_estimada]'] = contractData.duracion || 'DURACIÓN ESTIMADA NO ESPECIFICADA';
                break;
                
            case 'determinado':
                template = determinadoTemplate;
                // Agregar reemplazos específicos para determinado
                replacements['[motivo]'] = contractData.motivo || 'MOTIVO NO ESPECIFICADO';
                replacements['[duracion]'] = contractData.duracion || 'DURACIÓN NO ESPECIFICADA';
                break;
                
            case 'indeterminado_prueba':
                template = indeterminadoPruebaTemplate; // Asegúrate de tener este template
                // Agregar reemplazos específicos para periodo de prueba
                replacements['[tipo_empleado]'] = contractData.tipo_empleado || 'TIPO NO ESPECIFICADO';
                replacements['[dias_prueba]'] = contractData.prueba || 'DÍAS NO ESPECIFICADOS';
                break;
                
            case 'indeterminado_capacitacion':
                template = indeterminadoCapacitacionTemplate; // Asegúrate de tener este template
                // Agregar reemplazos específicos para capacitación
                replacements['[tipo_empleado]'] = contractData.tipo_empleado || 'TIPO NO ESPECIFICADO';
                replacements['[meses_capacitacion]'] = contractData.prueba || 'MESES NO ESPECIFICADOS';
                break;
                
            case 'indeterminado_temporada':
                template = indeterminadoTemporadaTemplate; // Asegúrate de tener este template
                // Agregar reemplazos específicos para temporada
                replacements['[razon_temporada]'] = contractData.razon || 'RAZÓN NO ESPECIFICADA';
                replacements['[duracion_temporada]'] = contractData.temporada || 'TEMPORADA NO ESPECIFICADA';
                replacements['[fin_temporada]'] = contractData.fin_temporada || 'FECHA NO ESPECIFICADA';
                break;
                
            case 'indeterminado':
                template = indeterminadoTemplate; // Asegúrate de tener este template
                break;
                
            default:
                template = determinadoTemplate;
                console.warn('Tipo de contrato no reconocido, usando template por defecto');
        }

        // Reemplazar todos los placeholders en el template
        let populatedTemplate = template;
        Object.entries(replacements).forEach(([placeholder, value]) => {
            const regex = new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
            populatedTemplate = populatedTemplate.replace(regex, value);
        });

        // Limpiar placeholders que no fueron reemplazados
        populatedTemplate = populatedTemplate.replace(/\[\w+\]/g, 'NO ESPECIFICADO');

        return populatedTemplate;
    };



    const handleExport = async(item) => {
       toast.info("Exportando contrato...");
  
        try {
            // 1. Crear elemento temporal
            const tempDiv = document.createElement('div');
            tempDiv.style.position = 'fixed';
            tempDiv.style.left = '-9999px';
            tempDiv.style.top = '0';
            tempDiv.style.width = '210mm';
            tempDiv.style.background = 'white';
            document.body.appendChild(tempDiv);

            // 2. Poblar el template con los datos
            const populatedTemplate = populateTemplate(item);
            tempDiv.innerHTML = populatedTemplate;

            // 3. Esperar a que se renderice el contenido
            await new Promise(resolve => setTimeout(resolve, 100));

            // 4. Obtener la sección del template
            const templateSection = tempDiv.querySelector('#document-template');
            
            if (!templateSection) {
                throw new Error('No se pudo encontrar la sección del contrato');
            }

            // 5. Generar PDF
            const canvas = await html2canvas(templateSection, {
                scale: 1.5, // Reducir de 2 a 1.5 (suficiente para PDF)
                useCORS: true,
                backgroundColor: '#ffffff',
                width: templateSection.scrollWidth,
                height: templateSection.scrollHeight,
                logging: false,
                removeContainer: true
            });

            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgData = canvas.toDataURL('image/jpeg', 0.65);
            
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = pdfWidth / imgWidth;
            
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, imgHeight * ratio);
            
            // 6. Configurar metadatos
            pdf.setProperties({
                title: `Contrato Obra - ${item.nombre}`,
                subject: 'Contrato individual de trabajo por obra determinada',
                author: 'Sistema de Contratos',
                creator: 'Avalco'
            });

            // 7. Descargar
            const fileName = `CONTRATO_OBRA_${item.nombre.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;
            pdf.save(fileName);

            // 8. Limpiar
            document.body.removeChild(tempDiv);
            
            toast.success("PDF exportado exitosamente");
            
        } catch (error) {
            console.error('Error exportando PDF:', error);
            toast.error("Error al exportar el PDF");
            
            // Limpiar en caso de error
            const tempElements = document.querySelectorAll('[style*="left: -9999px"]');
            tempElements.forEach(el => el.remove());
        }
    }

    const handleDelete = (item) => {
        toast.warn('Eliminar')
        console.log(item)
    }

    const columns = [
        
        { 
            field: 'tipo', 
            headerName:'Documento', 
            width: 300,
            valueGetter: (params) => {
                const tipo = params;
                const match = contractTypes.find(ct => ct.value === tipo);
                return match ? match.label : tipo; 
            }
        },

        
      
        { 
            field: 'created_at', 
            headerName:'Fecha de creación', 
            width: 100,
            valueGetter: (params) => {
                const rawDate = params;
                if (!rawDate) return '';

                const fecha = new Date(rawDate);
                const dia = fecha.getDate();
                const mes = fecha.toLocaleString('es-MX', { month: 'long' });
                const año = fecha.getFullYear();

                return `${dia} de ${mes}, ${año}`;
            }
        },

        { 
            field: 'company_id', 
            headerName:'Patrón', 
            width: 150,
            valueGetter: (params) => {
                const id = params;
                const match = companies.find(ct => ct.id === id);
                return match ? match.nombre : id; 
            }
        },
       
        { field: 'nombre', headerName: 'Colaborador', width: 200 },

        {
            field: 'view',
            headerName: 'Acciones',
            width: 250,
            renderCell: (item) => (
                
                <>
                    
                    <button className='btn btn-primary' title='Exportar' onClick={(e)=>{handleExport(item.row)}}>
                        <svg fill="#ffffff" width="18px" height="18px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>print</title> <path d="M5.656 6.938l-0.344 2.688h11.781l-0.344-2.688c0-0.813-0.656-1.438-1.469-1.438h-8.188c-0.813 0-1.438 0.625-1.438 1.438zM1.438 11.094h19.531c0.813 0 1.438 0.625 1.438 1.438v8.563c0 0.813-0.625 1.438-1.438 1.438h-2.656v3.969h-14.219v-3.969h-2.656c-0.813 0-1.438-0.625-1.438-1.438v-8.563c0-0.813 0.625-1.438 1.438-1.438zM16.875 25.063v-9.281h-11.344v9.281h11.344zM15.188 18.469h-8.125c-0.188 0-0.344-0.188-0.344-0.375v-0.438c0-0.188 0.156-0.344 0.344-0.344h8.125c0.188 0 0.375 0.156 0.375 0.344v0.438c0 0.188-0.188 0.375-0.375 0.375zM15.188 21.063h-8.125c-0.188 0-0.344-0.188-0.344-0.375v-0.438c0-0.188 0.156-0.344 0.344-0.344h8.125c0.188 0 0.375 0.156 0.375 0.344v0.438c0 0.188-0.188 0.375-0.375 0.375zM15.188 23.656h-8.125c-0.188 0-0.344-0.188-0.344-0.375v-0.438c0-0.188 0.156-0.344 0.344-0.344h8.125c0.188 0 0.375 0.156 0.375 0.344v0.438c0 0.188-0.188 0.375-0.375 0.375z"></path> </g></svg>
                    </button>

                    <button className='btn btn-primary' title='Eliminar' onClick={()=>handleDelete(item.row)}>
                        X
                    </button>
                    
                </>
            )
        }
               
    ];
    

    const handleChangeType = (event) => {
       
        setSelectedType(event.target.value);
      
    };

    const handleCreateDocument = () =>{
        if(selectedType == ''){
            toast.error("Selecciona el tipo")
        }else{
            navigate("/admin/contract", { state: {new: selectedType} });
        }
    }


    const fetchDocuments = async () => {
        try {
           
            const response = await axios.get(`${endpoint}admin/contracts/company/${selectedCompany.id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log(response.data)
            setDocuments(response.data)
           
        } catch (error) {
            toast.error('Error al obtener documentos');
        }
    };


    const fetchCompanies = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/companies`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCompanies(response.data);
            console.log(response.data)
            if(response.data.length > 0){
                // verificar que todas las companies tengan un address 

                let allHaveAddress = true;
                for (const company of response.data) {
                    if (!company.addresses || company.addresses.length === 0 ) {    
                        allHaveAddress = false;
                        break;
                    }   
                }
                if (!allHaveAddress) {
                    toast.warn("Todas las empresas deben tener una dirección registrada. Actualiza la información para continuar.");
                    setTimeout(()=>{
                        navigate('/admin'); 
                    },5000);
                    return; // Salir de la función si alguna empresa no tiene dirección
                }

                setSelectedCompany(response.data[0]);
            }else{
                toast.warn("No tienes ninguna empresa registrada. Crea una para continuar.")
                setTimeout(()=>{
                    navigate('/admin'); 
                },4000);
            }
        } catch (error) {
            toast.error('Error al obtener la lista de companias')
        }
    };

    const fetchCollaborators = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/collaborators`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            
            setCollaborators(response.data);
            
            if(selectedCompany.id)
                setCompanyCollaborators(response.data.filter(collaborator=>collaborator.company_id === selectedCompany.id))
            
            //console.log(response.data)
        } catch (error) {
            toast.error('Error al obtener la lista de colaboradores')
        }
    };
    

    useEffect(()=>{
       
        fetchDocuments();

    },[selectedCompany]);

    useEffect(()=>{
        fetchCompanies();
        fetchCollaborators();
    },[]);


    return(
        <div className="documents">
            <NavBar auth={status} companies={companies} selected={selectedCompany} set={setSelectedCompany}/>
            <div className='documents-row'>
                <Menu/>
                <div className='documents-wrapper'>
                    <ToastContainer />
                    <h2>Documentos</h2>

                    <div className="documents-controls">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar documento..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        <span>
                            
                        
                   
                            <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createModal">
                                Agregar documento
                            </button>
                          
                         

                        </span>
                        
                    </div>

                    <div style={{ height: '80vh', width: '100%' }} className='documents-table'>
                        <DataGrid
                            rows={documents}
                            columns={columns}
                            sx={{ borderColor: 'white' }}
                            pageSize={5}
                            //onRowDoubleClick={()=>{document.getElementById('view').click(); setForm();}}
                            onRowClick={(row) => {setDocument(row.row);}}
                            
                        />
                    </div>
                    
                </div>
            </div>

    
            <div class="modal fade" id="createModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Crear documento</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <label htmlFor="">Tipo de documento</label>
                        <select 
                            id="contract-type"
                            className="form-control"
                            value={selectedType}
                            onChange={handleChangeType}
                        >
                            <option value="">Elige una opción</option>
                            {contractTypes.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div class="modal-footer">
                       
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" onClick={handleCreateDocument}>Continuar</button>
                    </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Documents;